import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'jumpType',
})
export class JumpTYpeTranslatePipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        product: '商品',
        coupon: '优惠券',
        fullDiscountActivity: '满减活动',
        discountActivity: '第X件Y折活动',
        purchasePremium: '加价购活动',
        memberShipPlan: '会员卡页面',
        distribution: '分销',
        customPage: '自定义页面',
      }[value] || value
    );
  }
}
